import { TEST_ENV_URL } from '../api/constants';

export const isDev = (type: 'replyBot' | 'localhost' | 'both' = 'both'): boolean => {
  const isDev = import.meta.env.DEV;

  if (type === 'replyBot') {
    return window.location.host === TEST_ENV_URL;
  }

  if (type === 'localhost') {
    return isDev;
  }

  // both
  return window.location.host === TEST_ENV_URL || isDev;
};
